import request from '@/utils/request'

export function getBugReport(param,isNotify) {
  return request({
    url: '/api/bugReport/getBugReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getBugReportDetail(param,isNotify) {
  return request({
    url: '/api/bugReport/getBugReportDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function saveBugReport(param, isNotify) {
  return request({
    url: '/api/bugReport/saveBugReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function deleteBugReport(param, isNotify) {
  return request({
    url: '/api/bugReport/deleteBugReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}

export function requestBugReportReconfirm(param) {
  return request({
    url: '/api/bugReport/requestBugReportReconfirm',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' }
  })
}
